import './footerDesktop.scss';

import React, { FunctionComponent } from 'react';

import { FooterContact } from './FooterContact';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../../primitives';

type FooterDesktopProps = {
    customerServiceInfo: Queries.contactUsInformationFragmentFragment;
    technicalSupportInfo: Queries.contactUsInformationFragmentFragment;
};

export const FooterDesktop: FunctionComponent<FooterDesktopProps> = (
    props: FooterDesktopProps
) => {
    const { t } = useTranslation('mainLayout');
    const { customerServiceInfo, technicalSupportInfo } = props;

    const { currentLocale } = usePageLocalization();

    return (
        <div className='row footer-content-desktop'>
            <div className='footer-products'>
                <ul>
                    <LocalizedLink className='link' to='/wood-stoves/'>
                        <>{t('footer.stoves') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/wood-inserts/'>
                        <>{t('footer.inserts') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/archives/'>
                        <>{t('footer.parts') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/accessories/'>
                        <>{t('accessories') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/promotions/'>
                        <>{t('promotions') || ''}</>
                    </LocalizedLink>
                </ul>
            </div>

            <div className='footer-help'>
                <ul>
                    <LocalizedLink className='link' to='/about/'>
                        <>{t('about') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/installer/'>
                        <>{t('footer.findinstaller') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/articles/'>
                        <>{t('footer.articles') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/test-reports/'>
                        <>{t('footer.testing-reports') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/warranty/'>
                        <>{t('warranty') || ''}</>
                    </LocalizedLink>
                    <LocalizedLink className='link' to='/order-status/'>
                        <>{t('order-status-title') || ''}</>
                    </LocalizedLink>
                </ul>
            </div>

            <div className='footer-contact'>
                <p className='contactTitle'><>{t('contact-us-title') || ''}</></p>
                <FooterContact
                    contactInformation={customerServiceInfo}
                    contactType='CustomerService'
                />
                <FooterContact
                    contactInformation={technicalSupportInfo}
                    contactType='TechnicalSupport'
                />
            </div>
        </div>
    );
};
